import React from 'react';
import { FILTER } from '@fiverr-private/listing_lib';
import Toggle from '../toggle';
import { PersonalAssistantToggleProps } from './PersonalAssistantToggle.types';

export const PersonalAssistantToggle = ({ filter, ...rest }: PersonalAssistantToggleProps) => {
    if (!filter) return null;

    return (
        <Toggle
            selectedValue={FILTER.PERSONAL_ASSISTANT.SELECTED_VALUE}
            title={'search_perseus.filters.global.personal_assistant.alias'}
            text={'search_perseus.filters.global.personal_assistant.text'}
            {...filter}
            {...rest}
        />
    );
};
